import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  MenuItem,
  Typography,
  Paper,
  IconButton,
  Select,
  Chip,
  colors,
  Input,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  ButtonGroup,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  Tooltip,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import API from "../../../network/dashboardAPI";
import { useHistory } from "react-router";
import { Spinner } from "react-bootstrap";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import ConfirmModal from "./components/confirmModal";
import ActionBar from "./components/actionsBar";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  conditionBlock: {
    border: `1px solid ${theme.palette.primary.main}`,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: "5px",
  },
  orBlock: {
    marginBottom: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.primary.dark,
  },
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  chipInput: {
    marginTop: theme.spacing(1),
  },
  itemSelect: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.4),
  },
  logo: {
    width: theme.spacing(10),
    height: theme.spacing(10),
    objectFit: "contain",
  },
}));

const ListLandingPage = () => {
  const classes = useStyles();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [dialogImgOpen, setDialogImgOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [list, setList] = useState([]);
  const [confirmModal, setConfirmModal] = useState(false);
  const [pageId, setPageId] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");
  const WebURL = process.env.REACT_APP_WEB_URL || "https://delishop.asia/";
  const handleDelete = (page_id) => {
    setConfirmModal(!confirmModal);
    setPageId(page_id);
  };

  const handleSearch = (e) => {
    let text = e.target.value;
    setSearch(text);
  }

  const handleFilterChange = (e) => {
    setPage(0)
    setFilter(e.target.value);
  }

  const deleteSlot = async () => {
    if (pageId !== 0) {
      await API.adminDeletePagesSelection(pageId)
        .then((res) => res.json())
        .then(async (res) => {
          if (res.success) {
            setConfirmModal(false);
            await getPages();
          }
        });
    }
  };
  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [mounted, setMounted] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setMounted(false);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value));
    setMounted(false);
  };

  const handleOpenDialogImgOpen = (item = {}) => {
    return () => {
      setDialogImgOpen((prev) => !prev);
      setSelectedItem(item);
    };
  };

  const getPages = async () => {
    setLoading(true);
    await API.adminGetProductsSelection("landing_page",page, rowsPerPage, search, filter)
      .then((response) => response.json())
      .then((response) => {
        if (response.success) {
          let data = response.data.data.data;
          setList(data);
          setTotalPage(response.data.data.total);
          setLoading(false);
        }else{
          setList([])
          setLoading(false);
          alert(response.message)
        }
      });
  };
  const setupPage = () => {
    history.push("/admin/products-selection/landing_page/add");
  };

  const editPage = (id) => {
    history.push(`/admin/products-selection/landing_page/update?id=${id}`);
  };

  const [copySuccess, setCopySuccess] = useState("");

  const copyToClipboard = (textToCopy) => {
    navigator.clipboard
      .writeText(
        WebURL + "page/" + textToCopy
      )
      .then(() => {
        setCopySuccess("Text copied to clipboard!");
      })
      .catch((err) => {
        setCopySuccess("Failed to copy text!");
      });
  };
  const handleChangeStatus = async (page_id, status,type) => {
    let body = {
      type: type,
    }
    await API.adminUpdatePagesStatus(page_id, status,body)
      .then((response) => response.json())
      .then(async (response) => {
        if (response.success) {
          console.log(response);
          await getPages();
          setLoading(false);
        }
      });
  };
  useEffect(() => {
    getPages();
  }, [page, rowsPerPage, search, filter]);

  return (
    <Paper className={classes.root}>
      <Typography variant="h5" gutterBottom>
        Products Collection
      </Typography>
      <ActionBar
          search={search}
          handleSearch={handleSearch}
          filter={filter}
          handleFilterChange={handleFilterChange}
          setupPage={setupPage}
      />

      <Box className={classes.orBlock}>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell component="th">Id</TableCell>
                <TableCell component="th">Logo</TableCell>
                <TableCell component="th">Title</TableCell>
                <TableCell component="th">
                  Description
                </TableCell>
                <TableCell component="th">Order</TableCell>
                <TableCell
                  component="th"
                  align="center"
                  style={{
                    position: "sticky",
                    borderRight: "1px solid #e0e0e0",
                    right: 0,
                    zIndex: 10,
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={7}>
                    <Spinner size="sm" animation="border" /> Loading...
                  </TableCell>
                </TableRow>
              ) : list?.length ? (
                list?.map((item) => {
                  return (
                    <TableRow key={item.id} hover>
                      <TableCell>{item.page_id}</TableCell>
                      <TableCell>
                        <Paper
                          onClick={handleOpenDialogImgOpen(item)}
                          className="my-2 p-1 cursor-pointer"
                          style={{
                            width: "80px",
                            height: "80px",
                            borderRadius: "50%",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            alt={item?.title}
                            src={item?.logo}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              borderRadius: "50%",
                            }}
                          />
                        </Paper>
                      </TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell className="text-nowrap" style={{ whiteSpace: "normal" }}>
                        <p
                          className="text-truncate"
                          style={{
                            display: '-webkit-box',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2, // Limits the text to 2 lines
                            overflow: 'hidden',
                            whiteSpace: 'normal', // Ensure text wraps properly
                          }}
                        >
	                        {item.description}
                        </p>
                      </TableCell>
                      <TableCell>{item.order}</TableCell>
                      <TableCell
                        align="center"
                        style={{
                          position: "sticky",
                          borderLeft: "1px solid #e0e0e0",
                          right: 0,
                          backgroundColor: "#fff",
                          zIndex: 3,
                        }}
                      >
                        <div
                          className="d-flex align-items-center justify-content-end"
                          style={{ height: "100%" }}
                        >
                          <Tooltip title="Show On Menu">
                            <Switch
                              checked={item?.show_on_menu == 1 ? true : false}
                              onChange={(e) => {
                                handleChangeStatus(
                                  item.page_id,
                                  item?.show_on_menu == 1 ? 0 : 1,
                                  "show_on_menu"
                                );
                              }}
                              color="primary"
                              name="checkedB"
                              inputProps={{ "aria-label": "primary checkbox" }}
                            />
                          </Tooltip>
                          <Tooltip title="Status">
                            {item?.status == 1 ? (
                              <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                style={{minWidth: "100px"}}
                                onClick={(e) => {
                                  handleChangeStatus(
                                    item.page_id,
                                    item?.status == 1 ? 0 : 1,
                                    "status"
                                  );
                                }}
                              >
                                Active
                              </Button>
                            ) : (
                              <Button
                                style={{minWidth: "100px"}}
                                onClick={(e) => {
                                  handleChangeStatus(
                                    item.page_id,
                                    item?.status == 1 ? 0 : 1,
                                    "status"
                                  );
                                }}
                                variant="contained"
                                size="small"
                                color="secondary"
                              >
                                InActive
                              </Button>
                            )}
                          </Tooltip>
                          <IconButton
                            onClick={() => editPage(item.page_id)}
                            aria-label="delete"
                          >
                            <EditIcon style={{ color: colors.blue[800] }} />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() => handleDelete(item.page_id)}
                          >
                            <DeleteIcon style={{ color: colors.red[800] }} />
                          </IconButton>
                          <IconButton
                            onClick={() => copyToClipboard(item.slug)}
                            aria-label="copy"
                          >
                            <FileCopyIcon
                              style={{ color: colors.green[600] }}
                            />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    No Data
                  </TableCell>
                </TableRow>
              )}
              <TableRow></TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalPage}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
      <Dialog
        open={dialogImgOpen}
        maxWidth="xs"
        onClose={handleOpenDialogImgOpen({})}
      >
        <DialogTitle>{selectedItem?.title}</DialogTitle>
        <DialogContent dividers>
          <div className="d-flex justify-content-center align-items-center">
            <img
              style={{
                display: "inline",
                width: 300,
                height: "auto",
                objectFit: "contain",
                aspectRatio: "1/1",
              }}
              src={selectedItem?.logo}
              alt={selectedItem?.title}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="contained"
            onClick={handleOpenDialogImgOpen({})}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmModal
        page_id={1}
        confirmModal={confirmModal}
        handleDelete={handleDelete}
        deleteSlot={deleteSlot}
      />
    </Paper>
  );
};
export default ListLandingPage;
